import React from 'react';
import { Link } from 'react-router-dom';

function Footer({ translations: t }) {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-brand">
            <img src="/longway-logo.png" alt="Longway AI" className="footer-logo" />
            <p className="footer-tagline">{t.slogan}</p>
          </div>
          <div className="footer-col">
            <h4>{t.footerProducts}</h4>
            <ul>
              <li><Link to="/solutions?product=virtual-mentor">{t.productVirtualMentor}</Link></li>
              <li><Link to="/solutions?product=smartflow">{t.productSmartFlow}</Link></li>
              <li><Link to="/solutions?product=translide">{t.productTranslide}</Link></li>
              <li><Link to="/solutions?product=gressio">{t.productGressio}</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>{t.footerCompany}</h4>
            <ul>
              <li><Link to="/">{t.home}</Link></li>
              <li><Link to="/solutions">{t.solutions}</Link></li>
              <li><Link to="/contact">{t.contactUs}</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>{t.footerContact}</h4>
            <ul>
              <li><a href="mailto:contact@long-agi.com">contact@long-agi.com</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {t.footer}</p>
          <div className="footer-legal">
            <Link to="/privacy">{t.footerPrivacy}</Link>
            <Link to="/terms">{t.footerTerms}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
